module.exports = __webpack_public_path__ + "static/media/icon-title-christmas-Tree1.f1275f7a.png";